export class BeadPos {
    public row: number;
    public col: number;
    
    constructor(_row: number, _col: number) {
        this.row = _row;
        this.col = _col;
    }
}